// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The ParameterEntryCycle status
 */
export type ParameterEntryCycleStatus = 'in_progress' | 'completed' | 'in_review' | 'reviewed' | 'rejected' | 'approved' | 'submitted' | 'submission_error';

export const ParameterEntryCycleStatus = {
    in_progress: 'in_progress' as ParameterEntryCycleStatus,
    completed: 'completed' as ParameterEntryCycleStatus,
    in_review: 'in_review' as ParameterEntryCycleStatus,
    reviewed: 'reviewed' as ParameterEntryCycleStatus,
    rejected: 'rejected' as ParameterEntryCycleStatus,
    approved: 'approved' as ParameterEntryCycleStatus,
    submitted: 'submitted' as ParameterEntryCycleStatus,
    submission_error: 'submission_error' as ParameterEntryCycleStatus
};

